import { useMemo, useState } from 'react'
import AtivoPatrimonialHttp from '../../../../services/api/https/patrimonio/ativo-patrimonial.http'
import MovimentacaoDevolucaoHttp from '../../../../services/api/https/patrimonio/movimentacao-devolucao.http'
import PatrimonioOwnerHttp from '../../../../services/api/https/patrimonio/patrimonio-owner.http'
import { getTps } from '../../../../services/localstorage/localstorage.service'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_RECEIPTS: 'Adquirindo Movimentações de Devolução',
  FILTERING: 'Filtrandos Movimentações de Devolução',
  CANCEL: 'Cancelando Devolução',
  ISSUE_RECEIPT: 'Emitindo recibo de Devolução',
}

const INITIAL_STATE = {
  movimentacoes: [],
  globalFilter: '',
  periodo: getPeriodoMesAtual(),
  modal: {
    show: false,
    data: null,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useMovimentacaoDevolucao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getMovimentacoesDevolucao(pInicial, pFinal, tpId) {
        MovimentacaoDevolucaoHttp.getMovimentacoesDevolucao(pInicial, pFinal, tpId)
          .then(movimentacoes =>
            setState(prevState => ({
              ...prevState,
              movimentacoes: movimentacoes,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp)
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_RECEIPTS }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
      },

      onModalEvent(action, payload) {
        switch (action) {
          case 'save':
            setState(prevState => {
              const index = prevState.movimentacoes.findIndex(mov => mov.id === payload.id)
              if (index !== -1) prevState.movimentacoes[index] = payload
              else prevState.movimentacoes.push(payload)
              prevState.modal.show = false
              prevState.modal.data = null
              return { ...prevState }
            })
            break

          case 'close':
            setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
            break

          default:
            break
        }
      },

      onNovoClick(selectedTp) {
        if (selectedTp) setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
        else
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um Operador Logístico' }))
      },

      onBtnPesquisarClick(dataInicial, dataFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial, dataFinal },
          loadingMessage: LOAD_MESSAGE.FILTERING,
        }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onMenuItemClick(menuItem, item, history) {
        switch (menuItem) {
          case 'Editar':
            setState(prevState => ({ ...prevState, modal: { show: true, data: item } }))
            break

          case 'Emitir Comprovante':
            MovimentacaoDevolucaoHttp.emitirComprovante(item.id)
            break

          case 'Upload Comprovante':
            history.push({
              pathname: '/main/patrimonio/movimentacao-devolucao/upload-comprovante',
              state: { movimentacao_id: item.id },
            })
            break

          default:
            break
        }
      },

      async onBtnExportarExcel(movimentacoes) {
        let allOwners = ''
        let allPatrimonios = []

        await PatrimonioOwnerHttp.fetchOwners()
          .then(owners => (allOwners = owners))
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
            })),
          )

        await AtivoPatrimonialHttp.fetchAtivos()
          .then(patrimonios => (allPatrimonios = patrimonios))
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )

        const colunas = [
          [
            'id',
            'data_movimentacao',
            'tp',
            'nome_transportadora',
            'num_viagem',
            'patrimonio_owner',
            'placa',
            'patrimonios',
            'qte_total',
            'observações',
          ],
        ]

        movimentacoes.forEach(m => {
          const patrimonioOwnerName = allOwners.find(ao => (ao.id = m.patrimonio_owner_id)).name
          m.patrimonios.forEach(p => {
            colunas.push([
              m.id,
              m.data_movimentacao,
              getTps().find(tp => tp.id === m.tp_id).name,
              m.nome_transportadora,
              m.num_viagem,
              patrimonioOwnerName,
              m.placa,
              allPatrimonios.find(aP => aP.id === p.patrimonio_ativo_id).name,
              p.qte_total,
              m.observacoes,
            ])
          })
        })

        gerarArquivoExcel(
          'entregas',
          colunas,
          `movimentacoes_devolucao_${new Date().toLocaleString().slice(0, 10)}.xlsx`,
        )
      },
    }
  }, [])

  return { state, localDispatch }
}
